import React , { useRef, useEffect, useState } from 'react';
import './Profile.css';
import Navbar from '../../components/Navbar/Navbar';
import ContactUs from '../../components/ContactUs/ContactUs';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserProvider';
import axios from "axios";
import { background, Button, ButtonGroup, Toast, useToast } from '@chakra-ui/react'
import InvoiceDownload from '../OrderSummaryPage/InvoiceDownload';
import { 
  Modal, 
  ModalOverlay, 
  ModalContent, 
  ModalHeader, 
  ModalFooter, 
  ModalBody, 
  ModalCloseButton, 
  Image,
  Box,
  Text,
  VStack,
  HStack,
  Divider,
  useDisclosure,
  Input
} from '@chakra-ui/react';

const Profile = () => {
  const toast= useToast();
  const location= useLocation();
  const {user, loading}= useUser();
    const contactUsRef = useRef(null);
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [primaryAddress, setPrimaryAddress] = useState('');

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [returnReason, setReturnReason] = useState('');
    

    const handleCreateReturnRequest= async() =>{
      try{

     
        const body= {
          order_id: selectedOrder.orderId,
          reason: returnReason
        }

        // console.log("body", body);

        const response= await axios.post("https://leatherandstyle.netlify.app/.netlify/functions/createReturnRequest", body);

        if(response.status==200){
          toast({
            title: 'Return Request Created',
            description: 'Your return request has been created successfully.',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: "top-right",
            });

            onClose();
        }


      }catch(e){
        console.log("error in creating the return request",e);
        toast({
          position: "top-right",
          title: "Error",
          description: "Failed to create return request",
          status: "error",
          duration: 3000,
        })
      }
    }
  
    const handleOpenModal = (order) => {

      setSelectedOrder(order);
      onOpen();

      const products = order.products;
      const totalAmount = products.reduce(
        (sum, product) => sum + (product.pricePerUnit || 0) * (product.quantity || 0),
        0
      );
      const totalDiscount = products.reduce(
        (sum, product) =>
          sum + ((product.discountPerUnit || 0) / 100) * (product.pricePerUnit || 0) * (product.quantity || 0),
        0
      );
      const totalPayable = totalAmount - totalDiscount + 40;

      const invoiceData = {
        orderId: order.orderId,
        mihpayid: order.mihpayid,
        updatedAt: order.updatedAt,
        shippingDetails: {
          first_name: order.shipping.firstName,
          last_name: order.shipping.lastName,
          phone: order.shipping.phone,
          address: order.shipping.address,
        },
        products: products.map((product) => ({
          name: product.name,
          quantity: product.quantity,
          price: product.pricePerUnit,
          discount: product.discountPerUnit,
          total:
            (product.pricePerUnit || 0) * (product.quantity || 0) -
            ((product.discountPerUnit || 0) / 100) * (product.pricePerUnit || 0) * (product.quantity || 0),
        })),
        totalAmount,
        totalDiscount,
        totalPayable,
      };

      setInvoiceData(invoiceData);
    };
  
    const handleOrderAction = () => {
      if (selectedOrder.shipping.status.toLowerCase() === 'new') {
        alert('Order cancelled!');
        // Add cancel logic here
      } else if (selectedOrder.shipping.status.toLowerCase() === 'delivered') {
        alert('Order return initiated!');
        // Add return logic here
      }
      onClose();
    };
   

    const [isAddressSaved, setIsAddressSaved] = useState(false);
    const [orderData, setOrderData]= useState([]);

    const [invoiceData, setInvoiceData] = useState(null);

    // const handleDownloadInvoice = (order) => {
    //   const products = order.products;
    //   const totalAmount = products.reduce(
    //     (sum, product) => sum + (product.pricePerUnit || 0) * (product.quantity || 0),
    //     0
    //   );
    //   const totalDiscount = products.reduce(
    //     (sum, product) =>
    //       sum + ((product.discountPerUnit || 0) / 100) * (product.pricePerUnit || 0) * (product.quantity || 0),
    //     0
    //   );
    //   const totalPayable = totalAmount - totalDiscount + 40;

    //   const invoiceData = {
    //     orderId: order.orderId,
    //     mihpayid: order.mihpayid,
    //     updatedAt: order.updatedAt,
    //     shippingDetails: {
    //       first_name: order.shipping.firstName,
    //       last_name: order.shipping.lastName,
    //       phone: order.shipping.phone,
    //       address: order.shipping.address,
    //     },
    //     products: products.map((product) => ({
    //       name: product.name,
    //       quantity: product.quantity,
    //       price: product.pricePerUnit,
    //       discount: product.discountPerUnit,
    //       total:
    //         (product.pricePerUnit || 0) * (product.quantity || 0) -
    //         ((product.discountPerUnit || 0) / 100) * (product.pricePerUnit || 0) * (product.quantity || 0),
    //     })),
    //     totalAmount,
    //     totalDiscount,
    //     totalPayable,
    //   };

    //   setInvoiceData(invoiceData);
    // };


    


 
    

    const [first_name, setFirst_name] = useState(user?.first_name || '');
        const [last_name, setLast_name] = useState(user?.last_name || '');
        const [phno, setPhno] = useState(user?.phno || '');
        const [pincode, setPincode] = useState(user?.pincode || '');
        const [locality, setlocality]= useState(user?.locality || '');
        const [address, setAddress] = useState(user?.address || '');
        const [city, setCity]= useState(user?.city || '');
        const [state, setState]= useState(user?.state || '');
        const [landmark, setLandmark]= useState(user?.landmark || '');
        const [altphno, setAltPhno]= useState(user?.alt_phno || '');
        
        const [productInfo, setProductInfo]= useState([]);
        const [showBarDetails, setShowBarDetails]= useState(true);
        const [isEditing, setIsEditing] = useState(false);
        const [isAnimating, setIsAnimating] = useState(false); 

       
        const [showReturnReasonInput, setShowReturnReasonInput] = useState(false);

      
    
        const allDetailsProvided =
        first_name &&
        last_name &&
        phno &&
        pincode &&
        locality &&
        address &&
        city &&
        state;
    
        const toggleEditing = async () => {
          if (isEditing) {
              try {
                  const token = localStorage.getItem('token');
      
                  if (!token) {
                      console.error('Authorization token is missing');
                      return;
                  }
      
                  const response = await axios.post(
                      'https://leatherandstyle.netlify.app/.netlify/functions/saveAddress',
                      {
                          phno,
                          pincode,
                          locality,
                          address,
                          city,
                          state,
                          landmark,
                          alt_phno: altphno
                      },
                      {
                          headers: {
                              'Content-Type': 'application/json',
                              'Authorization': `Bearer ${token}`
                          }
                      }
                  );
      
                  if (response.status === 200) {
                      toast({
                        title: 'Address Saved Successfully',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: 'top-right'
                      })
                      setIsAnimating(true);
      
                      setTimeout(() => {
                          setIsEditing(false);
                          setIsAnimating(false);
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 500);
                  } else {
                      console.error('Error saving address:', response.data.error);
                  }
              } catch (error) {
                  console.error('Error saving address:', error);
              }
          } else {
              setIsEditing(true);
          }
      };
      
  




      const fetchUserOrders = async () => {
        try {
            const response = await axios.post(`https://leatherandstyle.netlify.app/.netlify/functions/getUserOrders`, {
                userId: user.id,
            });
    
            if (response.status === 200) {
                setOrderData(response.data);
                // console.log("orderData:", response.data);
                let prodIds= [];
                for(let order of response.data){
                  for(let product of order.products){
                    prodIds.push(product.id);
                  }
                }
                // console.log("proIds:", prodIds);

              
            } else {
                console.log('Failed to fetch order details');
            }
        } catch (e) {
            console.log('Error in fetching order details:', e);
        }
    }
    
    useEffect(() => {
        fetchUserOrders();
    }, []);
    

      const handleSaveAddress = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch('https://leatherandstyle.netlify.app/.netlify/functions/saveAddress', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ primary_address: primaryAddress }),
          });
    
          const data = await response.json();
          if (response.ok) {
            alert('Primary address saved successfully!');
            setIsEditing(false); // Exit edit mode after saving
          } else {
            console.error('Error saving address:', data.error);
          }
        } catch (error) {
          console.error('Error saving address:', error);
        }
      };
    
      const handleEditAddress = () => {
        setIsEditing(true);
      };

    const handleLogout = () => {
        localStorage.removeItem('token'); 
        alert('You have been logged out successfully.');
        window.scrollTo({ top: 0});
        navigate('/login'); 
      };

      const scrollRef = useRef(null);

    const handleOpenCourierPage = (service) =>{
      if(service.toLowerCase()==="maruti"){
        window.open("https://shreemaruti.com/", "_blank")
      }else if(service.toLowerCase()==="dtdc"){
        window.open("https://www.dtdc.in/trace.asp", "_blank")
      }else if(service.toLowerCase()==="bluedart"){
        window.open("https://www.bluedart.com/tracking", "_blank")
      }
    }

    const handleCancelOrder = async (_id, status)=>{
      try{
        if(_id && status==="processing"){
          const body ={
            "_id": _id,
          }
          const response= await axios.post("https://leatherandstyle.netlify.app/.netlify/functions/cancelOrder", body);
          if(response.status===200){
            toast({
              title: "Order Cancelled Successfully",
              status: "success",
              duration: 2000,
              isClosable: true,
              position:"top-right"
            });
            await fetchUserOrders();
          }
        }

      }catch(e){
        console.log("err in cancelling the order");
        toast({
          title: "Error in cancelling the order",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top-right",
        })
      }
    } 




  return (
    <div className='Profile-container'>
        <Navbar contactUsRef={contactUsRef}/>
        <div className='Profile-main-container'>
            <div className='white-blur-screen'>
            <header className='profile-heading'>
                        Welcome! {location.state?.first_name || user?.first_name} { location.state?.first_name || user?.last_name},
            </header>
              
                <div className='right-part'>
                    <div className='button-area'>
                        <button className='profile-logout' onClick={handleLogout}>Logout</button>
                        <div className='container-header-os'>
                          Delivery Details
                        </div>
                        <div className="add-heading-underline"></div>
                        <div className={`details-bar ${isEditing ? "expanded" : ""}${
                          isAnimating ? "collapsing" : ""
                        }`}>
                        <div className="details-bar-area">
                        <div className="user-details" >
                          <div className="user-details-text">
                            <div className="ud-header" style={{fontWeight:'bold', textAlign:'left'}}>Deliver To:</div>
                            
                            {!isEditing ? (
                                <>
                                <div className="ud-user-data">
                                {allDetailsProvided ? (
                                    <>
                                      <span>
                                        {first_name} {last_name}
                                        {phno && `, 91+ ${phno}`}
                                      </span>
                                      <span>
                                        {address && `${address}`}
                                        {locality && `, ${locality}`}
                                        {landmark && `, ${landmark}`}
                                        {city && `, ${city}`}
                                        {state && `, ${state}`}
                                        {pincode && `, ${pincode}`}
                                        {altphno && `, 91+ ${altphno}`}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="warning-text">
                                      Full delivery details not provided. Click Edit to fill in the details.
                                    </span>
                                  )}

                               
                                </div>

                                </>
                              ) : (
                                <>
                                </>
                                
                              )}
                              
                            
                          </div>
                        </div>
                        <div className="bar-buttons">
                          <button
                            className={`edit-button ${isEditing ? "disabled": ""}`}
                            onClick={toggleEditing}
                            disabled={isEditing}
                          >
                            Edit
                          </button>
                        </div>
                        </div>
                        <div>
                        {isEditing && (
                       <div className="delivery-details-area">
                       <div className="name-inputs-container">
                         <div className="input-container">
                           <input type="text" id="first-name" className="name-input" placeholder=" " value={first_name} onChange={(e)=>{setFirst_name(e.target.value)}} required/>
                           <label htmlFor="first-name" className="placeholder-label">First Name</label>
                         </div>
                         <div className="input-container">
                           <input type="text" id="last-name" className="name-input" placeholder=" "  value={last_name} onChange={(e)=>{setLast_name(e.target.value)}} required/>
                           <label htmlFor="last-name" className="placeholder-label">Last Name</label>
                         </div>
                       </div>

                       <div className="phno-container">
                         <div className="input-container1">
                           <div className="phno-prefix">91+</div>
                           <div className="divider-line"></div>
                           <input type="number" id="phone-number" className="phno-input" placeholder=" " value={phno} onChange={(e)=>{setPhno(e.target.value)}} required/>
                           <label htmlFor="phone-number" className="placeholder-label1">Phone Number</label>
                         </div>
                       </div>

                     {/* Residential Address Section */}
                       <div className="address-section">
                         {/* Pincode and Locality */}
                         <div className="row">
                           <div className="input-container">
                             <input type="number" id="pincode" className="name-input" placeholder=" "  value={pincode} onChange={(e)=>{setPincode(e.target.value)}}/>
                             <label htmlFor="pincode" className="placeholder-label">Pincode</label>
                           </div>
                           <div className="input-container">
                             <input type="text" id="locality" className="name-input" placeholder=" " value={locality} onChange={(e)=>{setlocality(e.target.value)}}/>
                             <label htmlFor="locality" className="placeholder-label">Locality</label>
                           </div>
                         </div>

                         {/* Address (Area & Street) */}
                         <div className="text-area-container">
                           <textarea id="address" className="address-textarea" placeholder=" " value={address} onChange={(e)=>{setAddress(e.target.value)}}></textarea>
                           <label htmlFor="address" className="placeholder-label">Address (Area & Street)</label>
                         </div>

                         {/* City/District/Town and State */}
                         <div className="row">
                           <div className="input-container">
                             <input type="text" id="city" className="name-input" placeholder=" "  value={city} onChange={(e)=>{setCity(e.target.value)}}/>
                             <label htmlFor="city" className="placeholder-label">City/District/Town</label>
                           </div>
                         <div className="input-container">
                           <select id="state" className="name-input" value={state} onChange={(e)=>{setState(e.target.value)}}>
                             <option value="" disabled selected>Select State</option>
                             <option value="Andhra Pradesh">Andhra Pradesh</option>
                             <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                             <option value="Assam">Assam</option>
                             <option value="Bihar">Bihar</option>
                             <option value="Chhattisgarh">Chhattisgarh</option>
                             <option value="Delhi">Delhi</option>
                             <option value="Goa">Goa</option>
                             <option value="Gujarat">Gujarat</option>
                             <option value="Haryana">Haryana</option>
                             <option value="Himachal Pradesh">Himachal Pradesh</option>
                             <option value="Jharkhand">Jharkhand</option>
                             <option value="Karnataka">Karnataka</option>
                             <option value="Kerala">Kerala</option>
                             <option value="Madhya Pradesh">Madhya Pradesh</option>
                             <option value="Maharashtra">Maharashtra</option>
                             <option value="Manipur">Manipur</option>
                             <option value="Meghalaya">Meghalaya</option>
                             <option value="Mizoram">Mizoram</option>
                             <option value="Nagaland">Nagaland</option>
                             <option value="Odisha">Odisha</option>
                             <option value="Punjab">Punjab</option>
                             <option value="Rajasthan">Rajasthan</option>
                             <option value="Sikkim">Sikkim</option>
                             <option value="Tamil Nadu">Tamil Nadu</option>
                             <option value="Telangana">Telangana</option>
                             <option value="Tripura">Tripura</option>
                             <option value="Uttar Pradesh">Uttar Pradesh</option>
                             <option value="Uttarakhand">Uttarakhand</option>
                             <option value="West Bengal">West Bengal</option>
                           </select>
                           <label htmlFor="state" className="placeholder-label">State</label>
                         </div>
                       </div>

                       {/* Landmark and Alternate Phone */}
                       <div className="row">
                         <div className="input-container">
                           <input type="text" id="landmark" className="name-input" placeholder=" " value={landmark} onChange={(e)=>{setLandmark(e.target.value)}}/>
                           <label htmlFor="landmark" className="placeholder-label">Landmark (Optional)</label>
                         </div>
                         <div className="input-container">
                           <input type="number" id="alternate-phone" className="name-input" placeholder=" " value={altphno} onChange={(e)=>{setAltPhno(e.target.value)}}/>
                           <label htmlFor="alternate-phone" className="placeholder-label">Alternate Phone (Optional)</label>
                         </div>
                       </div>
                     </div>
                     <div className="row">
                    <button className="save-button" onClick={toggleEditing}>
                      Save
                    </button>
                  </div>
                   </div>
                      )}
                  </div>
                  </div>
                    </div>
                    <div className='address'>
                    </div>
                </div>
                <div className='left-part'>
                    <div className='nav-gav'>
                       
                    <div className="purchased-orders">
                        <div className="add-header">
                            Your Orders
                        </div>
                        

                        <div className="add-heading-underline"></div>
                        <div style={{textAlign:"left"}}>
                          *Click on the cards to get more information about orders
                        </div>
                        
                        {orderData.length > 0 ? (
                            <div className="order-carousel" ref={scrollRef}>
                                {orderData.map((order, index) => (
                                    <div key={index} className="order-card"  >
                                        {/* Products */}
                                        <div className="order-card2" onClick={() => handleOpenModal(order)}>
                                        <div className="product-list">
                                            {order.products.map((product, idx) => (
                                                <span key={idx} className="product-name">
                                                    {product.name}{idx !== order.products.length - 1 ? ', ' : ''}
                                                </span>
                                            ))}
                                        </div>

                                        {/* Total Amount */}
                                        <div className="order-detail">
                                            <span className="label">Amount Paid:</span>
                                            <span className="value">₹{order.payment.amount}</span>
                                        </div>

                                        {/* Download Invoice */}
                                        {/* <button className="download-btn" onClick={handleDownloadInvoice}>Download Invoice</button>
                                        {invoiceData?.orderId === order.orderId ? (
                                          <InvoiceDownload invoiceData={invoiceData} />
                                        ) : (
                                          <button
                                            className="download-btn"
                                            onClick={() => handleDownloadInvoice(order)}
                                          >
                                            Download Invoice
                                          </button>
                                        )} */}


                                        {/* Delivery Status */}
                                        <div className="order-detail">
                                            <span className="label">Status:</span>
                                            <span className={`status ${order.shipping.status.toLowerCase()}`}>
                                                {order.shipping.status}
                                            </span>
                                        </div>
                                        </div>

                                        {/* Tracking ID (if status = "couriered") */}
                                        {/*window.open("https://shreemaruti.com/", "_blank")*/}
                                        {order.shipping.status.toLowerCase() === 'couriered' && (
                                            <div className="tracking">
                                                <span className="tracking-id">{order.shipping.tracking_id}</span>
                                                <button 
                                                  className="track-btn" 
                                                  onClick={() => {handleOpenCourierPage(order.shipping.courier_service)}}
                                                >
                                                  Track Order
                                                </button>
                                                

                                            </div>
                                        )}

                                        {order.shipping.status.toLowerCase() === 'processing' && (
                                            <div className="tracking">
                                               
                                                <button 
                                                  className="track-btn" 
                                                  onClick={() => {handleCancelOrder(order._id, order.shipping.status.toLowerCase())}}
                                                >
                                                  Cancel Order
                                                </button>

                                            </div>
                                        )}
                                           
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div style={{ textAlign: "left" }}>No orders found</div>
                        )}

                           {/* Order Details Modal */}
                           {selectedOrder && (
                              <Modal isOpen={isOpen} onClose={onClose} size="lg">
                                <ModalOverlay backdropFilter="blur(8px)" bg="rgba(0, 0, 0, 0.4)" />
                                <ModalContent
                                  borderRadius="12px"
                                  boxShadow="lg"
                                  bg="rgba(255, 255, 255, 0.85)"
                                  style={{
                                    fontFamily: 'Gowun Batang',
                                    color: '#4A3225',
                                    maxHeight: '90vh', 
                                    overflowY: 'auto'
                                  }}
                                >
                                  <ModalHeader 
                                    fontSize="lg" 
                                    fontWeight="bold" 
                                    borderBottomWidth="1px"
                                    textAlign="center"
                                    color="#3B271F"
                                  >
                                    Order Details
                                  </ModalHeader>
                                  <ModalCloseButton _hover={{ bg: 'rgba(0,0,0,0.1)' }} />

                                  <ModalBody>
                                    {/* General Info */}
                                    <VStack align="start" spacing={4}>
                                      <Box>
                                        <Text fontWeight="bold">Order ID:</Text>
                                        <Text>{selectedOrder.orderId}</Text>
                                      </Box>
                                      <Box>
                                        <Text fontWeight="bold">Order Date:</Text>
                                        <Text>{new Date(selectedOrder.updatedAt).toLocaleDateString()}</Text>
                                      </Box>
                                    </VStack>

                                    <Divider my={4} borderColor="#D2B48C" />

                                    {/* Product Details */}
                                    {selectedOrder.products.map((product, idx) => (
                                      <HStack key={idx} align="start" spacing={4} my={2}>
                                        <Image 
                                          src={product.image} 
                                          boxSize="80px" 
                                          objectFit="cover" 
                                          borderRadius="8px"
                                          boxShadow="sm"
                                        />
                                        <VStack align="start" spacing={1}>
                                          <Text fontWeight="bold">{product.name}</Text>
                                          <Text>Actual Cost: ₹{product.pricePerUnit}</Text>
                                          <Text>Discounted Cost: ₹{product.total}</Text>
                                          <Text>Quantity: {product.quantity}</Text>
                                        </VStack>
                                      </HStack>
                                    ))}

                                    <Divider my={4} borderColor="#D2B48C" />

                                    {/* Order Info */}
                                    <VStack align="start" spacing={2}>
                                      <Text fontWeight="bold">Shipping Charges: ₹40</Text>
                                      <Text fontWeight="bold">Total Amount Paid: ₹{selectedOrder.payment.amount} </Text>
                                    </VStack>
                                    <Divider my={4} borderColor="#D2B48C" />
                                    <InvoiceDownload invoiceData={invoiceData} />

                                    <Divider my={4} borderColor="#D2B48C" />

                                    {/* Order Status */}
                                    <Box>
                                      <Text fontWeight="bold" mb={2}>Status: {selectedOrder.shipping.status}</Text>
                                      {selectedOrder.shipping.status.toLowerCase() === 'new' ? (
                                        <Button 
                                          colorScheme="red"
                                          onClick={handleOrderAction}
                                          size="md"
                                          _hover={{ bg: '#7B3F00', color: '#fff' }}
                                        >
                                          Cancel Order
                                        </Button>
                                      ) : selectedOrder.shipping.status.toLowerCase() === 'couriered' ? (
                                        <>

                                          {(() => {
                                            const updatedAt = new Date(selectedOrder.updatedAt);
                                            const currentDate = new Date();
                                            const diffInDays = Math.floor((currentDate - updatedAt) / (1000 * 60 * 60 * 24));

                                            // Assuming return is allowed within 7 days
                                             if (diffInDays <= 14) {
                                              return (
                                                <>
                                                <Button 
                                                  colorScheme="blue" 
                                                  onClick={() => setShowReturnReasonInput(true)}
                                                  size="md"
                                                  _hover={{ bg: '#7B3F00', color: '#fff' }}
                                                >
                                                  Return Order
                                                </Button>

                                            {showReturnReasonInput && (
                                              <VStack align="start" spacing={2} mt={4}>
                                                <Input
                                                  placeholder="Enter reason for return"
                                                  value={returnReason}
                                                  onChange={(e) => setReturnReason(e.target.value)}
                                                  borderColor="#D2B48C"
                                                  _focus={{ borderColor: '#7B3F00', boxShadow: 'none' }}
                                                />
                                                <Button
                                                  colorScheme="green"
                                                  onClick={handleCreateReturnRequest}
                                                  isDisabled={!returnReason.trim()}
                                                  _hover={{ bg: '#7B3F00', color: '#fff' }}
                                                >
                                                  Submit Request
                                                </Button>
                                              </VStack>
                                            )}

                                            </>
                                              );
                                            } else {
                                              return (
                                                <Button 
                                                  colorScheme="gray" 
                                                  isDisabled 
                                                  size="md"
                                                >
                                                  This order is not eligible for return request as per Return Policy
                                                </Button>
                                              );
                                            }
                                          })()}

                                          
                                        </>
                                      ) : null}
                                    </Box>
                                  </ModalBody>

                                  <ModalFooter>
                                    <Button 
                                      colorScheme="gray" 
                                      onClick={onClose}
                                      _hover={{ bg: '#7B3F00', color: '#fff' }}
                                    >
                                      Close
                                    </Button>
                                  </ModalFooter>
                                </ModalContent>
                              </Modal>
                            )}

                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref={contactUsRef}>
        <ContactUs/>
      </div>
    </div>
  )
}

export default Profile;
